<template>
	<div class="wid100">
		
		<div class="follline" :class="{noneline: isline}">
			
		
			<!-- 动态 class="drawerpage"  -->
			<div v-if="datalist.length" v-loading="loading"  >
				
				
				<div class="follow_box1" v-for="(item1,index1) in datalist">
					<div class="follow_tit1">
						{{item1.title || ''}}
					</div>
						
					<div class="follow_box2" v-for="(item2, index2) in item1.children">
						<div class="follow_tit2 ">
							
							<img :src="urlhead + '/pctime.png'" mode="aspectFit"></img>
							<span >
								{{item2.title || ''}}
							</span>
						</div>
						<div class="follow_item" v-for="(item3, index3) in item2.children">
							
							<div class="ri_content">
								<div class="timetil">
									<span>
										{{item3.time3 || ''}}
									</span>
									<div class="txts">
										查看了
										<span>
											 [{{item3.leixin}}]
										</span>
										{{item3.visit_time}}
									</div>
								</div>
								
								<div class="contets">
									<img :src="urlhead + item3.icon" mode="aspectFit"></img>
									<div class="teaxtatr danhang">
										{{item3.leixin_name}}
									</div>
								</div>
								
							</div>
										
						
						</div>
					</div>
				</div>
				
				<div class="btn_right" >
					<div >
						<el-pagination background layout="total,sizes, prev, pager, next" prev-text="上一页"
							next-text="下一页" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" :current-page="page"
							:pager-count='3' :total="total" @size-change="type_modify_page" @current-change="type_switch_page">
						</el-pagination> 
						
					</div>
				</div>
				
			</div>
			
			
			<!-- 没有数据 -->
			<template v-else>
				<nodata :show="true"></nodata>
			</template>
			<!-- v-show="show" -->
		</div>
	
	</div>
</template>

<script>
	var that

	import {
		getAllOpeRecord,
	} from 'network/hk_operset'
	import nodata from "@/components/content/publics/nodata.vue";
	export default {
		components: {
			nodata,
		},
		name: "dynamics",
		props: {
			// 
			show: {
				type: Boolean,
				default: false,
			},
			
			isline: {
				type: Boolean,
				default: false,
			},
			
			customer_id: {
				type: Number,
				default: 0,
			},
			
			cue_id: {
				type: Number,
				default: 0,
			},
			
			
			
			
			
		},
		data() {
			return {
			
				
				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/customer',
				
				pagesize: 10,
				page: 1,
				total: 0,
				
				datalist: [],
				loading: true,
			}
		},

		created() {
			that = this
			// 
			this.Refresh()
		},
		watch: {
			show(){
				if(this.show) {
					this.Refresh()
				}
			},
		},
		methods: {
			
			Refresh(){
				if(this.customer_id) {
					this.pagesize = 10
					this.page = 1
					this.total = 0
					this.fn_getAllOperati()
				}
				
				if(this.cue_id) {
					this.pagesize = 10
					this.page = 1
					this.total = 0
					this.fn_getAllOperati()
				}
				console.log(this.page,'this.pageRefresh')
			},
			
			// 切换页码1
			type_modify_page(val) {
				this.pagesize = val
				this.page = 1
				this.fn_getAllOperati()
			},
			type_switch_page(val) {
				this.page = val
				setTimeout(()=>{
					console.log(this.page,'this.page')
				}, 2000)
				this.fn_getAllOperati()
			},

			// 获取客户全部信息动态
			fn_getAllOperati() {
				this.loading = true
				this.datalist = []
				let data = {
					pagesize: this.pagesize,
					page: this.page,
				}
				if(this.cue_id) {
					data.cue_id = this.cue_id
				}
				if(this.customer_id) {
					data.customer_id = this.customer_id
				}
				getAllOpeRecord(data).then(res => {
					if (this.handlereq(res)) {
						let obj = res.result
						this.total = obj.total
						
						if (obj.data) {
							for (let item of obj.data) {
			
								if (item.article_id) {
									item.leixin = `文章`;
									item.leixin_name = `文章: ${item.name || ''}`;
									item.icon = '/fil1-2.png'
								} else if (item.card_id) {
									item.leixin = `名片 `;
									item.leixin_name = `${item.name} `;
									item.icon = '/fil1-1.png'
								} else if (item.goods_id) {
									item.leixin = `产品`;
									item.leixin_name = `产品: ${item.name || ''}`;
									item.icon = '/fil1-4.png'
								} else if (item.mat_id) {
									item.leixin = `素材文件`;
									item.leixin_name = `素材文件: ${item.name || ''}`;
									item.icon = '/fil2-1.png'
								} else if (item.form_id) {
									item.leixin = `表单`;
									item.leixin_name = `表单: ${item.name || ''}`;
									item.icon = '/fil1-5.png'
								}
			
			
								let s1 = item.start_time.split(' ')
			
								let s2 = s1[0].split('-') // 2022 07 30
			
								let s3 = s1[1].slice(0, 5) // 11:50
			
								item.time1 = `${s2[0]}年${s2[1]}月`
								item.time2 = `${s2[1]}月${s2[2]}日`
								item.time3 = s3
			
			
								let flag1 = this.datalist.some(v => v.title == item.time1)
								let index1 = this.datalist.findIndex(v => v.title == item.time1)
								if (flag1) {
									// 找得到
									let obj2 = this.datalist[index1].children
									let flag2 = obj2.some(v => v.title == item.time2)
									let index2 = obj2.findIndex(v => v.title == item.time2)
			
									if (flag2) {
										// 找得到
										let obj3 = obj2[index2].children
										obj3.push(item)
									} else {
										// 找不到
										let newEle = {
											title: item.time2,
											children: [],
										}
										newEle.children.push(item)
										obj2.push(newEle)
									}
								} else {
									// 找不到
									let newEle = {
										title: item.time1,
										children: [{
											title: item.time2,
											children: [],
										}]
									}
									newEle.children[0].children.push(item)
									this.datalist.push(newEle)
								}
			
							}
			
						}
			
					}
					this.loading = false
					let len = this.total || 0;
					this.$emit('retnum', len)
				})
			},


			// 弹出提示
			alertMess(message, type) {
				this.$message({
					showClose: true,
					offset: 100,
					duration: 2000,
					message,
					type: type ? type : 'success',
				});
			},
			handlereq(res) {
				if (res) {
					if (res.code === 10000) { // 请求成功
						return true
					} else { // 请求发生错误
						this.alertMess(res.message, 'error')
						return false
					}
				}
			},


		}
	}
</script>

<style scoped lang="scss">
	
	.mycust_none{
		width: 100%;
		min-height: 550px;
		image{
			width: 400px;
			display: block;
		}
		.none_txt{
			color: rgba(166, 166, 166, 1);
			font-size: 16px;
			margin-top: 20px;
		}
	}
	.follline{
		position: relative;
		width: 100%;
	}
	.follline.noneline::after{
		display:none;
	}
	.follline::after{
		content:'';
		display:block;
		right:0;
		top:0;
		width: 1px;
		height: 100%;
		z-index: 20;
		position: absolute;
		background-color: rgba(243, 243, 243, 1);
	}
	.btn_right{
		width: 100%;
		display:flex;
		justify-content: flex-end;

		position: sticky;
		bottom: 0;
		z-index: 10;
		background: #fff;
		padding: 10px;
		
	}
	
	.follow_box1 {
		width: 100%;
		margin-bottom: 30px;
		.follow_tit1 {
			position: relative;
			font-size: 16px;
			color: rgba(56, 56, 56, 1);
			display: flex;
			align-items: center;
			margin-bottom: 30px;
		}
	
		.follow_tit1::before {
			content: '';
			display: block;
			width: 3px;
			height: 20px;
			margin-right: 7px;
			background: rgba(43, 117, 235, 1);
		}
	
		.follow_box2 {
			// padding-left: 20px;
	
			.follow_tit2 {
				display:flex;
				margin-top: 38px;
				margin-bottom: 5px;
				img{
					width: 16px;
					height: 16px;
					display:block;
					margin-right: 10px;
				}
				span{
					font-size: 14px;
					color: #000;
					
					
				}
				
			}
			
			.follow_item {
				position: relative;
				padding:0 25px;
				padding-top: 20px;
				.ri_content::before{
					content:'';
					position: absolute;
					display:block;
					width: 10px;
					height: 10px;
					background: rgba(248, 249, 251, 1);
					transform: rotate(45deg);
					left: -5px;
					top: 12px;
					
				}
				.ri_content {
					position: relative;
					padding:14px 18px;
					width: 100%;
					// height: 118px;
					border-radius: 6px;
					opacity: 1;
					background: rgba(248, 249, 251, 1);
					
					.timetil{
						display:flex;
						align-items: center;
						>span{
							font-size: 14px;
							color: rgba(56, 56, 56, 1);
						}
						.txts{
							margin-left: 14px;
							font-size: 14px;
							color: rgba(128, 128, 128, 1);
							>span{
								font-size: 14px;
								color: rgba(56, 56, 56, 1);
							}
						}
					}
					
					.contets {
						margin-top: 11px;
						font-size: 14px;
						color: rgba(56, 56, 56, 1);
						width: 341px;
						padding:6px 8px ;
					
						border-radius: 5px;
						background: #fff;
						display:flex;
						align-items: center;
						
						img {
							width: 24px;
							height: 24px;
							border-radius: 3px;
							margin-right: 10px;
						}
						
						.teaxtatr {
							width: 272px;
							color: rgba(56, 56, 56, 1);
							font-size: 14px;
							font-weight: 500;
						}
					}
	
					
				}
							
			}
			
			
			.follow_item::before{
				position: absolute;
				content:'';
				display:block;
				left: 8px;
				top: 0;
				height: 100%;
				width: 1px;
				background-color: rgba(243, 243, 243, 1);
				z-index: 2;
			}
			.follow_item::after{
				position: absolute;
				content:'';
				display:block;
				left: 5px;
				top: 33px;
				border-radius: 100%;
				height: 7px;
				width: 7px;
				z-index: 3;
				background-color: rgba(42, 117, 234, 1);
			}
		
		}
	}
	
	
</style>
